export const BANK_ID_APP_URL_TEMPLATE = 'external_auth_launch';
